(() => {
  const loader = document.querySelector('[data-nord-loader]');
  const finish = () => {
    if (!loader) return;
    loader.classList.add('is-finished');
    document.body.classList.remove('nord-loading');
    try { sessionStorage.setItem('nord-intro-seen', '1'); } catch (_) {}
    window.setTimeout(() => loader.remove(), 800);
  };
  if (loader) {
    document.body.classList.add('nord-loading');
    let seen = false;
    try { seen = sessionStorage.getItem('nord-intro-seen') === '1'; } catch (_) {}
    if (seen || window.matchMedia('(prefers-reduced-motion: reduce)').matches) window.setTimeout(finish, 250);
    else window.setTimeout(finish, 5600);
    loader.querySelector('[data-nord-loader-skip]')?.addEventListener('click', finish);
  }
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting && entry.target.classList.add('is-visible')), { threshold: .12 });
  document.querySelectorAll('.nord-reveal').forEach((node) => observer.observe(node));

  const serviceHero = document.querySelector('.nord-service__hero');
  if (serviceHero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('pointermove', (event) => {
      const x = (event.clientX / window.innerWidth - .5) * 10;
      const y = (event.clientY / window.innerHeight - .5) * 7;
      serviceHero.style.setProperty('--nord-pointer-x', `${x}px`);
      serviceHero.style.setProperty('--nord-pointer-y', `${y}px`);
    }, { passive: true });
  }
  const homeCar = document.querySelector('[data-nord-car-tilt]');
  if (homeCar && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const resetCar = () => {
      homeCar.style.setProperty('--nord-car-rx', '0deg');
      homeCar.style.setProperty('--nord-car-ry', '0deg');
      homeCar.style.setProperty('--nord-car-x', '0px');
      homeCar.style.setProperty('--nord-car-y', '0px');
    };
    homeCar.addEventListener('pointermove', (event) => {
      const bounds = homeCar.getBoundingClientRect();
      const px = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width - .5) * 2));
      const py = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height - .5) * 2));
      homeCar.style.setProperty('--nord-car-rx', `${py * -3.5}deg`);
      homeCar.style.setProperty('--nord-car-ry', `${px * 5}deg`);
      homeCar.style.setProperty('--nord-car-x', `${px * 8}px`);
      homeCar.style.setProperty('--nord-car-y', `${py * 5}px`);
    }, { passive: true });
    homeCar.addEventListener('pointerleave', resetCar);
    resetCar();
  }
  const fitmentDataUrl = document.querySelector('#MainContent')?.dataset.nordFitmentUrl || '';
  let nordFitmentPromise;
  let nordKnownProductTypes = new Set();

  const loadNordFitment = async () => {
    if (!fitmentDataUrl) throw new Error('Fitment data URL is unavailable');
    if (!nordFitmentPromise) {
      nordFitmentPromise = fetch(fitmentDataUrl, { headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error(`Fitment data returned ${response.status}`);
        return response.json();
      }).then((data) => {
        nordKnownProductTypes = new Set((data.products || []).map((product) => normalizeText(product?.[4])).filter(Boolean));
        return data;
      });
    }
    return nordFitmentPromise;
  };

  const uniqueSorted = (values) => [...new Set(values.filter(Boolean))].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const normalizeText = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const compactPartCode = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const readSavedVehicle = () => {
    try { return JSON.parse(localStorage.getItem('nord-selected-vehicle') || 'null') || null; } catch (_) { return null; }
  };
  const vehicleIsComplete = (vehicle) => Boolean(vehicle && vehicle.year && vehicle.make && vehicle.model && vehicle.engine && vehicle.transmission);
  const fitmentUrlFor = (vehicle, part = '', exactType = '', category = '') => {
    const params = new URLSearchParams({
      fitment: '1',
      fy: vehicle.year || '',
      fm: vehicle.make || '',
      fmo: vehicle.model || '',
      fe: vehicle.engine || '',
      ft: vehicle.transmission || '',
    });
    const keyword = String(part || '').trim();
    const type = String(exactType || '').trim();
    const cat = String(category || '').trim();
    if (keyword) params.set('fp', keyword);
    if (type) params.set('fpt', type);
    if (cat) params.set('fcat', cat);
    return `/search?${params.toString()}`;
  };
  const catalogUrlFor = (exactType = '', category = '') => {
    const params = new URLSearchParams({ type: 'product' });
    const partType = String(exactType || '').trim();
    const cat = String(category || '').trim();
    if (partType) params.set('fpt', partType);
    if (cat) params.set('fcat', cat);
    return `/search?${params.toString()}`;
  };
  const managedSearchMount = () => document.querySelector('#NordManagedSearchMount');
  const showManagedSearchError = (message) => {
    const mount = managedSearchMount();
    if (!mount) return;
    mount.innerHTML = `<section class="nord-fitment-results nord-shell"><div class="nord-fitment-results__empty">${escapeHtml(message)}</div></section>`;
  };
  const nordKeywordTypeAliases = {
    rotor: ['brake disc'],
    rotors: ['brake disc'],
    'brake rotor': ['brake disc'],
    'brake rotors': ['brake disc'],
    disc: ['brake disc'],
    discs: ['brake disc'],
    'brake discs': ['brake disc'],
    pad: ['brake pads'],
    pads: ['brake pads'],
    'brake pad': ['brake pads'],
    'brake pads': ['brake pads'],
  };
  const nordKeywordAliases = {
    filter: ['filter'],
    filters: ['filter'],
  };
  const nordPhraseMatch = (searchable, phrase) => {
    const haystack = ` ${normalizeText(searchable)} `;
    const needle = normalizeText(phrase);
    return Boolean(needle) && haystack.includes(` ${needle} `);
  };
  const nordStrictProductMatch = (productMeta, rawQuery) => {
    const query = String(rawQuery || '').trim();
    if (!query) return true;
    const normalized = normalizeText(query);
    const compact = compactPartCode(query);
    const skuCompact = compactPartCode(productMeta?.[0]);
    const searchable = `${productMeta?.[2] || ''} ${productMeta?.[3] || ''} ${productMeta?.[4] || ''} ${productMeta?.[5] || ''}`;

    // SKU / part-number / OEM searches are intentionally strict.
    if (compact.length >= 4 && skuCompact === compact) return true;
    const codeLike = /\d/.test(query) && compact.length >= 5;
    if (codeLike) {
      if (nordPhraseMatch(searchable, query)) return true;
      const compactSearch = compactPartCode(productMeta?.[5]);
      return compactSearch.includes(`OEM${compact}`) || compactSearch.includes(`PARTNUMBER${compact}`);
    }

    // If the query names a known part type (or a deliberate synonym), lock results to that type.
    // Any extra words (for example a brand or position) must also match the same product.
    const productType = normalizeText(productMeta?.[4]);
    let typeNeedles = [];
    let matchedTypePhrase = '';
    const aliasPhrases = Object.keys(nordKeywordTypeAliases).sort((a, b) => b.length - a.length);
    for (const phrase of aliasPhrases) {
      if (nordPhraseMatch(normalized, phrase)) {
        typeNeedles = nordKeywordTypeAliases[phrase];
        matchedTypePhrase = phrase;
        break;
      }
    }
    if (!typeNeedles.length) {
      const knownTypes = [...nordKnownProductTypes].sort((a, b) => b.length - a.length);
      for (const phrase of knownTypes) {
        if (nordPhraseMatch(normalized, phrase)) {
          typeNeedles = [phrase];
          matchedTypePhrase = phrase;
          break;
        }
      }
    }
    if (typeNeedles.length) {
      if (!typeNeedles.includes(productType)) return false;
      const remaining = normalizeText(` ${normalized} `.replace(` ${matchedTypePhrase} `, ' '));
      if (!remaining) return true;
      return remaining.split(' ').filter((token) => token.length > 1).every((token) => nordPhraseMatch(searchable, token));
    }

    // Other named-part / keyword searches require the requested words to be present.
    const alternatives = [normalized, ...(nordKeywordAliases[normalized] || [])];
    if (alternatives.some((term) => nordPhraseMatch(searchable, term))) return true;
    const tokens = normalized.split(' ').filter((token) => token.length > 1);
    return tokens.length > 0 && tokens.every((token) => nordPhraseMatch(searchable, token));
  };
  const applyNordProductBrands = (root = document) => {
    root.querySelectorAll('product-card[data-nord-brand]').forEach((card) => {
      const brand = String(card.dataset.nordBrand || '').trim();
      if (!brand) return;
      const heading = card.querySelector('.nord-product-title-with-brand, [role="heading"], .text-block p');
      if (!heading || heading.querySelector('.nord-product-brand')) return;
      const brandSpan = document.createElement('span');
      brandSpan.className = 'nord-product-brand';
      brandSpan.textContent = brand;
      const sep = document.createElement('span');
      sep.className = 'nord-product-title-separator';
      sep.textContent = ' · ';
      heading.prepend(sep);
      heading.prepend(brandSpan);
    });
  };

  applyNordProductBrands();
  const brandObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes || []) {
        if (node.nodeType === 1) applyNordProductBrands(node.matches?.('product-card') ? node.parentElement || node : node);
      }
    }
  });
  brandObserver.observe(document.documentElement, { childList: true, subtree: true });

  // Normal header/search-icon searches always search the complete NORD catalogue.
  // Vehicle fitment is applied only when the customer submits the dedicated Parts Finder.

  const setSelectOptions = (select, values, firstLabel, selected = '') => {
    const items = uniqueSorted(values);
    select.replaceChildren(new Option(firstLabel, ''));
    items.forEach((value) => select.add(new Option(value, value, false, String(value).toLowerCase() === String(selected).toLowerCase())));
    select.disabled = false;
    if (items.length === 1 && !selected) {
      select.value = items[0];
      queueMicrotask(() => {
        if (select.value === items[0]) select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };
  const resetSelect = (select, label) => {
    select.replaceChildren(new Option(label, ''));
    select.disabled = true;
  };

  const fitmentForm = document.querySelector('[data-nord-fitment]');
  if (fitmentForm) {
    const apiBase = 'https://vpic.nhtsa.dot.gov/api/vehicles';
    const year = fitmentForm.querySelector('#NordYear');
    const make = fitmentForm.querySelector('#NordMake');
    const model = fitmentForm.querySelector('#NordModel');
    const modelFilter = null; // Removed redundant model/chassis search field
    const modelCount = fitmentForm.querySelector('[data-nord-model-count]');
    const partCategory = fitmentForm.querySelector('#NordPartCategory');
    const partType = fitmentForm.querySelector('#NordPartType');
    const engine = fitmentForm.querySelector('#NordEngine');
    const transmission = fitmentForm.querySelector('#NordTransmission');
    const vin = fitmentForm.querySelector('#NordVin');
    const status = fitmentForm.querySelector('[data-nord-fitment-status]');
    const decodeButton = fitmentForm.querySelector('[data-nord-vin-decode]');
    let fitmentData;
    let allModelValues = [];
    const engineField = engine?.closest('.nord-field');
    const transmissionField = transmission?.closest('.nord-field');
    const setPowertrainVisibility = (visible = true) => {
      if (engineField) engineField.hidden = !visible;
      if (transmissionField) transmissionField.hidden = !visible;
    };

    // Progressive vehicle selector: VIN and Year/Make first, then Model and refinements.
    const progressFields = Object.fromEntries(['model', 'engine', 'transmission', 'category', 'type', 'submit'].map((key) => [key, fitmentForm.querySelector(`[data-nord-progress="${key}"]`)]));
    const updateProgress = () => {
      const hasYearMake = Boolean(year.value && make.value);
      const hasModel = hasYearMake && Boolean(model.value);
      for (const key of ['model']) if (progressFields[key]) progressFields[key].hidden = !hasYearMake;
      for (const key of ['engine', 'transmission', 'category', 'type', 'submit']) if (progressFields[key]) progressFields[key].hidden = !hasModel;
      // Transmission is an optional refinement, displayed alongside Engine only after Model.
      if (progressFields.transmission) progressFields.transmission.hidden = !hasModel || (engineField?.hidden === true);
      if (progressFields.engine) progressFields.engine.hidden = !hasModel || (engineField?.hidden === true);
    };
    fitmentForm.addEventListener('change', () => queueMicrotask(updateProgress));
    const setStatus = (message, type = '') => {
      status.textContent = message;
      status.dataset.state = type;
    };
    const yearNode = () => fitmentData?.vehicles?.[year.value] || null;
    const makeNode = () => yearNode()?.[make.value] || null;
    const modelNode = () => makeNode()?.[model.value] || null;
    const engineNode = () => modelNode()?.[engine.value] || null;
    const expandedYearNode = () => fitmentData?.vehiclesExpanded?.[year.value] || yearNode();
    const expandedMakeNode = () => expandedYearNode()?.[make.value] || makeNode();
    const expandedModelNode = () => expandedMakeNode()?.[model.value] || modelNode();
    const expandedEngineNode = () => expandedModelNode()?.[engine.value] || engineNode();
    const productIdsForSelection = (modelTree, engineValue = '', transmissionValue = '') => {
      if (!modelTree) return [];
      const ids = [];
      const add = (values) => { if (Array.isArray(values)) ids.push(...values); };
      if (engineValue && modelTree[engineValue]) {
        const transmissions = modelTree[engineValue];
        if (transmissionValue && Array.isArray(transmissions[transmissionValue])) add(transmissions[transmissionValue]);
        else Object.values(transmissions).forEach(add);
      } else {
        Object.values(modelTree).forEach((transmissions) => Object.values(transmissions || {}).forEach(add));
      }
      return [...new Set(ids)];
    };
    const verifiedProductIds = () => {
      return productIdsForSelection(modelNode(), engine?.value || '', transmission?.value || '');
    };
    const compatibleProductIds = () => {
      const ids = productIdsForSelection(expandedModelNode(), engine?.value || '', transmission?.value || '');
      return ids.length ? ids : verifiedProductIds();
    };
    const catalogTaxonomy = () => fitmentData?.taxonomy || {};
    const categoryForType = (rawType) => {
      const value = String(rawType || '');
      return catalogTaxonomy()?.typeCategories?.[value] || 'Other Parts';
    };
    const allCatalogTypes = () => uniqueSorted((fitmentData?.products || []).map((product) => product?.[4] || '').filter(Boolean));
    const allCatalogCategories = () => {
      const configured = catalogTaxonomy()?.categories;
      return Array.isArray(configured) && configured.length ? configured : uniqueSorted(allCatalogTypes().map(categoryForType));
    };
    const compatibleTypeCounts = () => {
      const counts = new Map();
      compatibleProductIds().forEach((id) => {
        const type = fitmentData?.products?.[id]?.[4] || '';
        if (type) counts.set(type, (counts.get(type) || 0) + 1);
      });
      return counts;
    };
    const vehicleSelectionStarted = () => [year, make, model, engine, transmission].some((field) => Boolean(field?.value));
    // Year, make and model are sufficient for a vehicle search. Engine and
    // transmission narrow the result only when the customer chooses them.
    const vehicleSelectionComplete = () => [year, make, model].every((field) => Boolean(field?.value));

    const setPartCategoryOptions = (selected = '') => {
      const counts = vehicleSelectionComplete() ? compatibleTypeCounts() : new Map();
      const categoryCounts = new Map();
      counts.forEach((count, type) => {
        const category = categoryForType(type);
        categoryCounts.set(category, (categoryCounts.get(category) || 0) + count);
      });
      const fullCounts = catalogTaxonomy()?.categoryCounts || {};
      partCategory.innerHTML = '<option value="">All part categories</option>';
      allCatalogCategories().forEach((category) => {
        const verified = categoryCounts.get(category) || 0;
        const total = Number(fullCounts[category] || 0);
        const label = vehicleSelectionComplete()
          ? (verified ? `${category} — ${verified} fitment-listed` : `${category} — catalogue (check compatibility)`)
          : `${category}${total ? ` — ${total} products` : ''}`;
        const option = new Option(label, category);
        partCategory.add(option);
      });
      partCategory.disabled = false;
      if (selected && allCatalogCategories().includes(selected)) partCategory.value = selected;
    };

    const resetPartSelectors = (categoryLabel = 'All part categories') => {
      const selectedCategory = partCategory?.value || '';
      setPartCategoryOptions(selectedCategory);
      resetSelect(partType, 'All specific parts');
      partType.disabled = false;
    };

    const loadPartCategories = () => {
      const ids = compatibleProductIds();
      const selectedCategory = partCategory?.value || '';
      setPartCategoryOptions(selectedCategory);
      loadPartTypes();
      if (!vehicleSelectionComplete()) {
        setStatus(`Vehicle selection is optional. Browse all ${Number(fitmentData?.products?.length || 0).toLocaleString()} NORD products by category/subcategory, or complete the vehicle fields to restrict results to supplier-listed fitment.`, 'success');
        return;
      }
      if (!ids.length) {
        setStatus('No exact supplier-fitment rows were found for this exact vehicle. The full NORD catalogue remains browsable; use VIN/OEM verification before ordering.', 'warning');
        return;
      }
      setStatus(`${ids.length} fitment-matched catalogue products are available for this vehicle. Exact supplier rows are used first; conservative same-chassis/year continuity matches are included where the scrape has gaps. Confirm VIN/OEM before ordering.`, 'success');
    };

    const loadPartTypes = () => {
      const category = partCategory.value;
      const counts = vehicleSelectionComplete() ? compatibleTypeCounts() : new Map();
      let types = category
        ? allCatalogTypes().filter((type) => categoryForType(type) === category)
        : allCatalogTypes();
      // Keep other catalogue types discoverable even when supplier fitment is incomplete.
      // Unverified options are visibly separated from supplier-listed matches.
      partType.innerHTML = '<option value="">All specific parts</option>';
      const verified = [];
      const catalogueOnly = [];
      types.forEach((type) => {
        const count = counts.get(type) || 0;
        if (vehicleSelectionComplete() && count > 0) verified.push({type,count});
        else catalogueOnly.push({type,count});
      });
      verified.forEach(({type,count}) => partType.add(new Option(`${type} — ${count} matched`, type)));
      catalogueOnly.forEach(({type}) => {
        const total = Number(catalogTaxonomy()?.typeCounts?.[type] || 0);
        const suffix = vehicleSelectionComplete() ? ' — catalogue (check fitment)' : (total ? ` — ${total}` : '');
        partType.add(new Option(`${type}${suffix}`, type));
      });
      partType.disabled = false;
      if (category) {
        const verifiedTypes = verified.length;
        setStatus(vehicleSelectionComplete()
          ? `${verifiedTypes} matched ${category} part types are available for this vehicle. Leave “All specific parts” selected to show every matched ${category} product, or choose one exact part type.`
          : `${types.length} part types under ${category}. Select a specific part or leave “All specific parts” selected to browse the whole category.`, verifiedTypes || !vehicleSelectionComplete() ? 'success' : 'warning');
      }
    };


    const loadYears = () => {
      queueMicrotask(updateProgress);
      const years = Object.keys(fitmentData.vehicles || {}).sort((a, b) => Number(b) - Number(a));
      setSelectOptions(year, years, 'Select year');
      resetSelect(make, 'Select year first');
      resetSelect(model, 'Select year and make first');
      resetSelect(engine, 'Select model first');
      resetSelect(transmission, 'Select model first');
      resetPartSelectors();
      const makes = uniqueSorted(Object.values(fitmentData.vehicles || {}).flatMap((node) => Object.keys(node)));
      const minYear = years[years.length - 1];
      const maxYear = years[0];
      setStatus(`NORD FITMENT V31 loaded: ${Number(fitmentData?.products?.length || 0).toLocaleString()} products · ${Number(fitmentData.sourceRows || 0).toLocaleString()} supplier records · ${minYear}–${maxYear}. Year, make and model are sufficient; engine and transmission are optional refinements.`, 'success');
    };

    const loadMakes = (selected = '') => {
      queueMicrotask(updateProgress);
      const node = yearNode();
      if (!node) return resetSelect(make, 'Select year first');
      setSelectOptions(make, Object.keys(node), 'Select make', selected);
      resetSelect(model, 'Select year and make first');
      resetSelect(engine, 'Select model first');
      resetSelect(transmission, 'Select model first');
      resetPartSelectors();
    };
    const renderModelOptions = (values, selected = '') => {
      setSelectOptions(model, values, 'Select exact model / chassis / body', selected);
      if (modelCount) modelCount.textContent = `(${values.length} shown / ${allModelValues.length} total)`;
    };
    const loadModels = (selected = '') => {
      queueMicrotask(updateProgress);
      const node = makeNode();
      if (!node) {
        allModelValues = [];
        if (modelFilter) { modelFilter.value = ''; modelFilter.disabled = true; }
        if (modelCount) modelCount.textContent = '';
        return resetSelect(model, 'Select year and make first');
      }
      allModelValues = uniqueSorted(Object.keys(node));
      setPowertrainVisibility(true);
      if (modelFilter) { modelFilter.value = ''; modelFilter.disabled = false; }
      renderModelOptions(allModelValues, selected);
      resetSelect(engine, 'Select model first');
      resetSelect(transmission, 'Select model first');
      resetPartSelectors();
      setStatus(`${year.value} ${make.value}: ${allModelValues.length} exact supplier model / chassis variants available.`, 'success');
    };
    // VIN is never required. We display all engine/transmission choices actually
    // supplied for this year/make/model, not a synthetic VIN requirement.
    const readablePowertrain = (value, kind) => {
      const text = String(value || '');
      if (normalizeText(text).startsWith(`all ${kind} options`) || normalizeText(text).startsWith(`all ${kind}s`)) {
        return `All ${kind}s — supplier did not specify`;
      }
      return text;
    };
    const loadEngines = (selected = '') => {
      queueMicrotask(updateProgress);
      const node = modelNode();
      if (!node) return resetSelect(engine, 'Select model first');
      const choices = uniqueSorted(Object.keys(node));
      engine.replaceChildren(new Option('All engines (optional)', ''));
      choices.forEach(value => engine.add(new Option(readablePowertrain(value, 'engine'), value)));
      engine.disabled = false;
      if (selected && choices.includes(selected)) engine.value = selected;
      // Do not suppress powertrain controls just because supplier records are generic.
      setPowertrainVisibility(true);
      loadTransmissions();
      // Populate available categories as soon as Year + Make + Model are provided.
      loadPartCategories();
      queueMicrotask(updateProgress);
    };
    const loadTransmissions = (selected = '') => {
      const node = modelNode();
      if (!node) return resetSelect(transmission, 'Select model first');
      // With engine unselected, collect transmissions across every listed engine.
      const engines = engine.value && node[engine.value] ? [node[engine.value]] : Object.values(node);
      const choices = uniqueSorted(engines.flatMap(value => Object.keys(value || {})));
      transmission.replaceChildren(new Option('All transmissions (optional)', ''));
      choices.forEach(value => transmission.add(new Option(readablePowertrain(value, 'transmission'), value)));
      transmission.disabled = false;
      if (selected && choices.includes(selected)) transmission.value = selected;
      // No powertrain choice is required for category or part browsing.
      loadPartCategories();
    };

    const persistVehicleSelection = () => {
      try {
        const current = {
          year: year.value || '', make: make.value || '', model: model.value || '',
          engine: engine.value || '', transmission: transmission.value || '',
          part_category: partCategory?.value || '', part_type: partType?.value || '', vin: vin?.value || ''
        };
        if (current.year || current.make || current.model || current.engine || current.transmission) {
          localStorage.setItem('nord-selected-vehicle', JSON.stringify(current));
        }
      } catch (_) {}
    };
    year.addEventListener('change', () => { loadMakes(); persistVehicleSelection(); });
    make.addEventListener('change', () => { loadModels(); persistVehicleSelection(); });
    model.addEventListener('change', () => { loadEngines(); persistVehicleSelection(); });
    engine.addEventListener('change', () => { loadTransmissions(); persistVehicleSelection(); });
    transmission.addEventListener('change', () => { loadPartCategories(); persistVehicleSelection(); });
    partCategory?.addEventListener('change', () => { loadPartTypes(); persistVehicleSelection(); });
    partType?.addEventListener('change', persistVehicleSelection);
    modelFilter?.addEventListener('input', () => {
      const q = normalizeText(modelFilter.value);
      const filtered = !q ? allModelValues : allModelValues.filter((value) => normalizeText(value).includes(q));
      renderModelOptions(filtered);
      resetSelect(engine, 'Select model first');
      resetSelect(transmission, 'Select model first');
      resetPartSelectors();
    });

    const getJson = async (url, cacheKey) => {
      try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached) return JSON.parse(cached);
      } catch (_) {}
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Vehicle service returned ${response.status}`);
      const payload = await response.json();
      try { sessionStorage.setItem(cacheKey, JSON.stringify(payload)); } catch (_) {}
      return payload;
    };

    decodeButton.addEventListener('click', async () => {
      const cleanedVin = vin.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
      vin.value = cleanedVin;
      if (cleanedVin.length !== 17) {
        setStatus('Enter a complete 17-character VIN.', 'error');
        vin.focus();
        return;
      }
      decodeButton.disabled = true;
      setStatus('Decoding VIN…');
      try {
        const payload = await getJson(`${apiBase}/DecodeVinValues/${encodeURIComponent(cleanedVin)}?format=json`, `nord-vpic-vin-${cleanedVin}`);
        const vehicle = payload.Results?.[0] || {};
        if (!vehicle.Make || !vehicle.Model || !vehicle.ModelYear) throw new Error('VIN not decoded');
        const y = String(vehicle.ModelYear);
        if (!fitmentData.vehicles[y]) {
          throw new Error(`VIN decoded as ${y} ${vehicle.Make} ${vehicle.Model}, but NORD's current supplier fitment file does not contain model year ${y}.`);
        }
        year.value = y;
        loadMakes();
        const availableMakes = Object.keys(fitmentData.vehicles[y]);
        const matchedMake = availableMakes.find((item) => normalizeText(item) === normalizeText(vehicle.Make));
        if (!matchedMake) {
          throw new Error(`VIN decoded as ${y} ${vehicle.Make} ${vehicle.Model}, but ${vehicle.Make} is not in NORD's current supplier fitment catalogue.`);
        }
        make.value = matchedMake;
        loadModels();
        const modelValues = Object.keys(fitmentData.vehicles[y][matchedMake]);
        const decodedModel = normalizeText(vehicle.Model);
        const candidates = modelValues.filter((item) => {
          const n = normalizeText(item);
          return n === decodedModel || n.startsWith(`${decodedModel} `) || n.includes(` ${decodedModel} `) || n.startsWith(decodedModel);
        });
        if (candidates.length === 1) {
          model.value = candidates[0];
          loadEngines();
          if (vehicle.DisplacementL) {
            const prefix = `${Number(vehicle.DisplacementL).toFixed(1)}L`;
            const engineValues = Object.keys(modelNode() || {});
            const engines = engineValues.filter((item) => item.startsWith(prefix));
            if (engines.length === 1) {
              engine.value = engines[0];
              loadTransmissions();
            }
          }
          setStatus(`VIN decoded: ${y} ${matchedMake} ${candidates[0]}. Confirm engine and transmission before viewing parts.`, 'success');
        } else if (candidates.length > 1) {
          setSelectOptions(model, candidates, 'Select exact model / variant');
          resetSelect(engine, 'Select model first');
          resetSelect(transmission, 'Select model first');
          setStatus(`VIN decoded: ${y} ${matchedMake} ${vehicle.Model}. Select the exact model / body variant, engine and transmission.`, 'success');
        } else {
          setStatus(`VIN decoded: ${y} ${matchedMake} ${vehicle.Model}. Select the closest exact supplier model / variant, engine and transmission.`, 'warning');
        }
      } catch (error) {
        setStatus(error?.message || 'The VIN could not be decoded. Check it and try again.', 'error');
      } finally {
        updateProgress();
        decodeButton.disabled = false;
      }
    });

    fitmentForm.addEventListener('reset', () => {
      queueMicrotask(updateProgress);
      window.setTimeout(() => {
        setPowertrainVisibility(true);
        loadYears();
        vin.value = '';
        if (modelFilter) { modelFilter.value = ''; modelFilter.disabled = true; }
        resetPartSelectors();
        try { localStorage.removeItem('nord-selected-vehicle'); } catch (_) {}
      });
    });

    updateProgress();
    fitmentForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(fitmentForm);
      const category = String(data.get('part_category') || '').trim();
      const exactType = String(data.get('part_type') || '').trim();
      const started = vehicleSelectionStarted();
      const completeVehicle = vehicleSelectionComplete();

      // No vehicle is required for ordinary catalogue browsing.
      if (!started) {
        window.location.href = catalogUrlFor(exactType, category);
        return;
      }

      // A vehicle search needs year/make/model. Engine and transmission are
      // optional refinements and part category/type are optional filters.
      if (!completeVehicle) {
        setStatus('Complete Year → Make → Model, or press Clear vehicle to browse the full catalogue. Engine and transmission are optional.', 'error');
        return;
      }

      const selectedVehicle = {
        year: data.get('year'), make: data.get('make'), model: data.get('model'),
        engine: data.get('engine'), transmission: data.get('transmission')
      };
      try { localStorage.setItem('nord-selected-vehicle', JSON.stringify({ ...Object.fromEntries(data.entries()), ...selectedVehicle })); } catch (_) {}
      window.location.href = fitmentUrlFor(selectedVehicle, '', exactType, category);
    });

    loadNordFitment().then((data) => {
      fitmentData = data;
      loadYears();
    }).catch(() => {
      setStatus('The NORD fitment catalogue could not be loaded. Refresh the page or email sales@nordautoparts.ca for help.', 'error');
      decodeButton.disabled = true;
    });
  }

  // NORD v17: search result rendering lives only in nord-search-v17.js.

})();

;(() => {
  const headings = document.querySelectorAll('.nord-home h1, .nord-home h2, .nord-home h3');
  headings.forEach(h => h.classList.add('nord-heading-animate'));
  if (!('IntersectionObserver' in window)) { headings.forEach(h=>h.classList.add('is-heading-visible')); return; }
  const io = new IntersectionObserver(entries => entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('is-heading-visible'); io.unobserve(e.target); } }), {threshold:.18, rootMargin:'0px 0px -5% 0px'});
  headings.forEach(h=>io.observe(h));
})();
